import React from "react";
import * as styles from "./PanelComponent.module.scss";
import { Divider } from "cprime-foundational-components";
import { useDispatch, useSelector } from "react-redux";
import {
  createApi,
  deleteApi,
  editApi,
} from "../../store/slices/createApiSlice";
import { incrementTableRefresh } from "../../store/slices/apiDetailsSlice";
import { AppDispatch, RootState } from "../../store/store";
import { triggerToast } from "../../utils/toast";
import Button from "../Common/CprimeButton";
const scssClass = styles as any;

interface ApiFooterButtonsProps {
  isEdit: boolean;
  onCancel: () => void;
  getApplicationDetails: any;
}

const ApiFooterButtons: React.FC<ApiFooterButtonsProps> = ({
  isEdit,
  onCancel,
  getApplicationDetails,
}) => {
  const saveApiData = useSelector(
    (state: RootState) => state?.apiDetails?.saveData,
  );
  const editApiData = useSelector(
    (state: RootState) => state?.apiDetails?.editData,
  );

  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = React.useState(false);
  const [deleteLoading, setDeleteLoading] = React.useState(false);

  const handleSave = async () => {
    if (isEdit === false) {
      setLoading(true);
      const body = {
        id: saveApiData?.id,
        apiName: saveApiData?.api_name,
        description: saveApiData?.description?.trim(),
        endpointPath: saveApiData?.endpointPath,
        appId: saveApiData?.appId,
        methodType: saveApiData?.methodType?.toUpperCase(),
      };
      try {
        const result = await dispatch(createApi(body)).unwrap();
        if (result?.status === true) {
          triggerToast("Data created successfully", "success");
          onCancel();
          dispatch(incrementTableRefresh());
        }
      } catch (error) {
        triggerToast("Error Creating API", "error");
      } finally {
        setLoading(false);
      }
    }
    if (isEdit === true) {
      setLoading(true);
      const body = {
        id: editApiData?.id,
        apiName: saveApiData?.api_name,
        description: saveApiData?.description?.trim(),
        endpointPath: saveApiData?.endpointPath,
        appId: saveApiData?.appId,
        methodType: saveApiData?.methodType?.toUpperCase(),
      };
      try {
        const result = await dispatch(editApi(body)).unwrap();
        if (result?.status === true) {
          triggerToast("Data updated successfully", "success");
          onCancel();
          dispatch(incrementTableRefresh());
          getApplicationDetails?.();
        }
      } catch (error) {
        triggerToast("Error Updating API", "error");
      } finally {
        setLoading(false);
      }
    }
  };

  const checkDisabled = () => {
    if (
      !isEdit &&
      saveApiData !== undefined &&
      saveApiData?.api_name !== "" &&
      saveApiData?.description !== "" &&
      saveApiData?.endpointPath !== "" &&
      saveApiData?.methodType !== ""
    ) {
      return false;
    }

    if (
      isEdit &&
      (saveApiData?.api_name !== editApiData?.api_name ||
        saveApiData?.description?.trim() !== editApiData?.description?.trim() ||
        saveApiData?.endpointPath !== editApiData?.endpoint_path ||
        (saveApiData?.methodType &&
          saveApiData?.methodType?.toUpperCase() !==
            editApiData?.method_type?.toUpperCase()))
    ) {
      return false;
    }
    return true;
  };

  const onDelete = async () => {
    setDeleteLoading(true);
    try {
      const result = await dispatch(deleteApi(editApiData?.id)).unwrap();
      if (result?.status === true) {
        triggerToast("Api deleted successfully", "success");
        onCancel();
        dispatch(incrementTableRefresh());
        getApplicationDetails?.();
      } else {
        triggerToast(result?.message, "error");
      }
    } catch (error) {
      triggerToast("Error deleting Api", "error");
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <div className={scssClass.bottomPanel}>
      <Divider
        variant={"fullWidth"}
        sx={{
          marginBottom: "15px",
          width: "100%",
          marginLeft: "0px !important",
          backgroundColor: "#f8f8f9 !important",
        }}
      />
      <div className={scssClass.footerButtons}>
        <div className={scssClass.leftButtons}>
          {isEdit && (
            <Button variant="danger" onClick={onDelete} loading={deleteLoading}>
              Delete API
            </Button>
          )}
        </div>
        <div className={scssClass.rightButtons}>
          <Button
            variant="tertiary"
            sx={{ marginRight: "10px" }}
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            sx={{ marginLeft: "5px" }}
            onClick={handleSave}
            disabled={checkDisabled()}
            loading={loading}
          >
            Save API
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ApiFooterButtons;
